import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 30px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2276.1 1223">
    <defs>
      <clipPath id="u">
        <path d="M403.85 322.06l411.41 39.816v537.81l-412.88 56.63z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(.86194 -441.35 -441.35 -.86194 608.97 850.45)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#646464" />
        <stop offset="0.898" stopColor="#464646" />
        <stop offset="1" stopColor="#464646" />
      </linearGradient>
      <clipPath id="o">
        <path d="M1496.7 322.06l-411.41 39.816v537.81l412.88 56.63z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="rotate(-90.112 1070.145 -219.265) scale(441.35084)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#646464" />
        <stop offset="0.898" stopColor="#464646" />
        <stop offset="1" stopColor="#464646" />
      </linearGradient>
      <clipPath id="n">
        <path d="M1114.4 359.56H788.89v540.12h325.51z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(-1.7373 -326.9 -326.9 1.7373 952.64 807.22)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#faaf40" />
        <stop offset="0.877" stopColor="#f6851e" />
        <stop offset="1" stopColor="#f6851e" />
      </linearGradient>
      <clipPath id="m">
        <path d="M378.39 990.37V318.33l-22.469 3.734v658.37z" />
      </clipPath>
      <linearGradient
        id="l"
        x2="1"
        gradientTransform="scale(668.912 -668.912) rotate(84.471 1.063 -.461)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#828282" />
        <stop offset="0" stopColor="#828282" />
        <stop offset="0.898" stopColor="#464646" />
        <stop offset="1" stopColor="#464646" />
      </linearGradient>
      <clipPath id="x">
        <path d="M1522.1 990.37V318.33l22.469 3.734v658.37z" />
      </clipPath>
      <linearGradient
        id="k"
        x2="1"
        gradientTransform="rotate(-95.529 1230.32 -217.455) scale(668.912)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#828282" />
        <stop offset="0" stopColor="#828282" />
        <stop offset="0.898" stopColor="#464646" />
        <stop offset="1" stopColor="#464646" />
      </linearGradient>
      <clipPath id="w">
        <path d="M1166.2 575.56H740.42v239.5h425.78z" />
      </clipPath>
      <linearGradient
        id="j"
        x2="1"
        gradientTransform="scale(426.64 -426.64) rotate(33.014 4.096 2.182)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="v">
        <path d="M620.72 583.99h-96.206l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="i"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 572.11 583.99)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="t">
        <path d="M620.72 507.4h-96.206l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="h"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 572.11 507.4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="s">
        <path d="M620.72 432.84h-96.206l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 572.11 432.84)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="r">
        <path d="M620.72 356.48h-96.206l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 572.11 356.48)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="q">
        <path d="M1462.9 717.04h-211.91v7.696h211.91z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1251 720.89)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="p">
        <path d="M1462.9 280.09h-211.91v7.696h211.91z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1251 283.93)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
    </defs>
    <path
      fill="#e6e7e8"
      d="M0 0h-1707.1l289.52 178.34h1117.1z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(1803.4 210.64)"
    />
    <path
      fill={themeColor || '#f6921e'}
      d="M96.329 191.73h1707.1v18.057H96.329z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <g
      clipPath="url(#u)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#d)"
        d="M403.85 322.06l411.41 39.816v537.81l-412.88 56.63z"
      />
    </g>
    <g
      clipPath="url(#o)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#b)"
        d="M1496.7 322.06l-411.41 39.816v537.81l412.88 56.63z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path fill={themeColor || 'url(#a)'} d="M1114.4 359.56H788.89v540.12h325.51z" />
    </g>
    <path
      fill="#58595b"
      d="M0 0l-1.461 634.25 412.88-56.629v23.282l-436.88 67.405V-3.732z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(403.85 322.06)"
    />
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#l)"
        d="M378.39 990.37V318.33l-22.469 3.734v658.37z"
      />
    </g>
    <path
      fill="#404041"
      d="M0 0v-22.166l384.51-49.989 28.365 15.525z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(402.39 956.31)"
    />
    <path
      fill="#58595b"
      d="M0 0l1.461 634.25-412.88-56.629v23.282l436.88 67.405V-3.732z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(1496.7 322.06)"
    />
    <g
      clipPath="url(#x)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#k)"
        d="M1522.1 990.37V318.33l22.469 3.734v658.37z"
      />
    </g>
    <path
      fill="#404041"
      d="M0 0v-22.166l-384.51-49.989-28.364 15.525z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(1498.1 956.31)"
    />
    <path
      fill={themeColor || '#f6921e'}
      d="M0 0v207.36l25 3.553.461-207.18z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(378.39 318.33)"
    />
    <path
      fill={themeColor || '#e8821c'}
      d="M0 0l-22.469 3.734v251.8L0 207.364z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(378.39 318.33)"
    />
    <path
      fill={themeColor || '#e8821c'}
      d="M0 0v207.36l-25 3.553-.461-207.18z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(1522.1 318.33)"
    />
    <path
      fill={themeColor || '#f6921e'}
      d="M0 0l22.469 3.734v251.8L0 207.364z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(1522.1 318.33)"
    />
    <g
      clipPath="url(#w)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path fill="url(#j)" d="M1166.2 575.56H740.42v239.5h425.78z" />
    </g>
    <path
      fill="none"
      stroke="#59595c"
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M1166.2 575.56H740.42v239.5h425.78z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <path
      fill="#404041"
      d="M0 0h-171.96l16 410.55H-14z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(658.38 296.34)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-120.96l-10 410.55H11z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(633.38 296.34)"
    />
    <g
      clipPath="url(#v)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#i)"
        d="M620.72 583.99h-96.206l-6 107.21h107.21z"
      />
    </g>
    <g
      clipPath="url(#t)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path fill="url(#h)" d="M620.72 507.4h-96.206l-6 107.21h107.21z" />
    </g>
    <g
      clipPath="url(#s)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#g)"
        d="M620.72 432.84h-96.206l-6 107.21h107.21z"
      />
    </g>
    <g
      clipPath="url(#r)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path
        fill="url(#f)"
        d="M620.72 356.48h-96.206l-6 107.21h107.21z"
      />
    </g>
    <path
      fill="#404041"
      d="M674.75 288.55H469.47v15.575h205.28z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <path
      fill="#4d4e4f"
      d="M0 0l-232.88 46v215.88L0 215.88z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(952.19 223.69)"
    />
    <path
      fill="#58595b"
      d="M0 0l232.88 46v215.88L0 215.88z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(951.19 223.69)"
    />
    <path
      fill="#414142"
      d="M0 0l105.03 17.268L232.88-8.285l121.77 26.596L464.77 0 231.89-47z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(719.81 485.72)"
    />
    <path
      fill={themeColor || '#e8821c'}
      d="M0 0v55.981l-195.62 33.021-36.268 60.596v-103.6z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(951.19 223.69)"
    />
    <path
      fill={themeColor || '#f6921e'}
      d="M0 0v55.981l195.62 33.021 36.268 60.596v-103.6z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6) translate(951.19 223.69)"
    />
    <path
      fill="#d0d2d3"
      d="M1457 287.04h-200v430h200z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <g
      clipPath="url(#q)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path fill="url(#e)" d="M1462.9 717.04h-211.91v7.696h211.91z" />
    </g>
    <path
      fill="#282827"
      d="M1251.4 713.34h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <path
      fill="#515050"
      d="M1466.8 713.34h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <g
      clipPath="url(#p)"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    >
      <path fill="url(#c)" d="M1462.9 280.09h-211.91v7.696h211.91z" />
    </g>
    <path
      fill="#282827"
      d="M1251.4 276.39h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <path
      fill="#515050"
      d="M1466.8 276.39h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
    <path
      fill="#e6e7e8"
      stroke="#bbbdbf"
      strokeMiterlimit="10"
      strokeWidth="4"
      d="M1259.1 875.06H640.71v231.9h618.39z"
      transform="matrix(1.3333 0 0 -1.3333 -128.44 1478.6)"
    />
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
